var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNetworkGeneral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 16.764a4 4 0 1 1-8 0 4 4 0 0 1 8 0M13 15.014a2 2 0 0 1 2-2h3.5a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2H15a2 2 0 0 1-2-2zM11.606 4.553a1 1 0 0 1 1.788 0l2.882 5.764a1 1 0 0 1-.894 1.447H9.618a1 1 0 0 1-.894-1.447z"
})));
export default SvgNetworkGeneral;